module.exports = "<div class=\"page\">\n  <div class=\"page-content w-100 mw-900 shadow no-p\">\n    <app-buro-form></app-buro-form>\n\n    <div class=\"d-flex align-items-center justify-content-center p-2\">\n      <app-button label=\"ver reporte buró completo\" [toAction]=\"true\" color=\"primary\"></app-button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/buro-page/buro-page.component.html
// module id = 1149
// module chunks = 0